"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OrientalMinimalismPhilosophy() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="223062" id="subscribe-media-enquiry" className="bg-background text-foreground w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 w-full min-h-[80vh]">
        {/* Left Side: Subscribe Form */}
        <div className="bg-primary text-primary-foreground flex flex-col justify-center items-start p-12 md:p-16 lg:p-24 xl:p-32 relative z-10">
          <div ref={textRef} className={`flex flex-col gap-8 max-w-2xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight tracking-tight">
              Subscribe to Reports
            </h2>
            
            <div className="flex flex-col gap-6 font-default text-lg md:text-xl leading-relaxed opacity-90">
              <p>
                Stay informed with the latest economic insights and market analysis from the Australian Institute of Business.
              </p>
              <div className="flex flex-col gap-4 w-full">
                <input type="email" placeholder="Email Address" className="bg-transparent border border-primary-foreground text-primary-foreground p-4 rounded-[2px] focus:outline-none focus:ring-1 focus:ring-primary-foreground transition-all" />
              </div>
            </div>

            <div className="pt-4">
              <Link to="#">
                <Button size="lg" className="bg-primary-foreground text-primary hover:bg-primary hover:text-primary-foreground border border-primary-foreground font-default text-base md:text-lg px-8 py-6 rounded-[2px] shadow-none transition-colors duration-200">
                  Join Mailing List
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {/* Right Side: Media Enquiry */}
        <div className="relative h-[50vh] lg:h-auto w-full bg-background flex flex-col justify-center items-center p-12 md:p-16 lg:p-24 xl:p-32 border-l border-primary/10">
          <div className="flex flex-col gap-8 max-w-2xl text-center lg:text-left">
            <h2 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-tight tracking-tight text-foreground">
              Media Enquiries
            </h2>
            <p className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground">
              For press releases, expert commentary, and data requests, our communications team is available to assist journalists and researchers.
            </p>
            <div className="pt-4">
              <Link to="/MediaCentrePage">
                <Button size="lg" className="bg-primary text-primary-foreground hover:bg-background hover:text-primary border border-primary font-default text-base md:text-lg px-12 py-8 rounded-[2px] shadow-none transition-colors duration-200 w-full lg:w-auto">
                  Contact Media Team
                </Button>
              </Link>
            </div>
          </div>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1664816/img/corporate_office_minimalist_detail.png" alt="Minimalist corporate office detail" className="absolute inset-0 w-full h-full object-cover opacity-5 pointer-events-none" loading="lazy" />
        </div>
      </div>
    </section>;
}